import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaDateInput from '../va-date-input/VaDateInput.vue'

export const VaDateInput = withConfigTransport(_VaDateInput)
